import { GET_EXTERNAL_ASSIGNED_LEADS, GET_EXTERNAL_ASSIGNED_LEADS_ERR } from '../../actionTypes/externalDashboardType'
import { getExternalAssignedLeadsApi} from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getExternalAssignedLeads = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.get(`${getExternalAssignedLeadsApi}/${payload}`, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: GET_EXTERNAL_ASSIGNED_LEADS,
            payload: data || {},
        });
    } catch (error) {   
        dispatch({
            type: GET_EXTERNAL_ASSIGNED_LEADS_ERR,
            payload: error && error.response
        });
    }
}


